import Vue from 'vue'

// 用 Vue.observable 实现轻量响应式 store（Vue2 方案）
const state = Vue.observable({
  lat: null,
  lng: null,
  gridValue: null,
  dataType: null,
  stationId: null,
  stationName: null
})

export default {
  state,

  setLocation({ lat, lng, gridValue = null, dataType = null }) {
    state.lat = lat
    state.lng = lng
    state.gridValue = gridValue
    state.dataType = dataType
    // 同步到 sessionStorage，供 API 拦截器读取
    try {
      sessionStorage.setItem('locationStore', JSON.stringify({
        lat, lng, gridValue, dataType
      }))
    } catch (e) { /* ignore */ }
  },

  setStation({ id, name }) {
    state.stationId = id
    state.stationName = name
  },

  clear() {
    state.lat = null
    state.lng = null
    state.gridValue = null
    state.dataType = null
    state.stationId = null
    state.stationName = null
    try {
      sessionStorage.removeItem('locationStore')
    } catch (e) { /* ignore */ }
  }
}
